<app-navbar-one></app-navbar-one>

<div class="main-banner-area-two">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="main-banner-content">
                            <img src="assets/img/home-two/logo_elevated.png"
                                class="img-logo  wow animate__animated animate__fadeInUp" data-wow-delay="0.6s"
                                alt="image" (click)="closeQrCodePopup()">
                            <h1>ElevateTech AI</h1>
                            <p style="font-size: 1.2rem;">Leverage our cutting-edge AI technologies to enhance
                                operational efficiency and drive innovation in your business processes.</p>
                            <div class="banner-btn">
                                <a href="https://website-6573a5b762f46-33281.getresponsesite.com/" target="_blank"
                                    class="default-btn">Get Started</a>
                                <a href="https://website-6573a5b762f46-33281.getresponsesite.com/" target="_blank"
                                    class="optional-btn">Contact Us</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="banner-image">
                            <img src="assets/img/home-two/1.png" class="wow animate__animated animate__fadeInUp"
                                data-wow-delay="0.6s" alt="image">
                            <img src="assets/img/home-two/2.png" class="wow animate__animated animate__fadeInDown"
                                data-wow-delay="0.6s" alt="image">
                            <img src="assets/img/home-two/3.png"
                                class="space_ship wow animate__animated animate__fadeInUp" data-wow-delay="0.6s"
                                alt="image">
                            <img src="assets/img/home-two/4.png" class="wow animate__animated animate__zoomIn"
                                data-wow-delay="0.6s" alt="image">
                            <img src="assets/img/home-two/5.png" class="wow animate__animated animate__fadeInDown"
                                data-wow-delay="0.6s" alt="image">
                            <img src="assets/img/home-two/main.png" class="wow animate__animated animate__zoomIn"
                                data-wow-delay="0.6s" alt="image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="banner-shape"><img src="assets/img/home-two/cloud.png" alt="image"></div>
    <div class="default-shape">
        <div class="shape-1"><img src="assets/img/shape/4.png" alt="image"></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/5.svg" alt="image"></div>
        <div class="shape-3"><img src="assets/img/shape/6.svg" alt="image"></div>
        <div class="shape-4"><img src="assets/img/shape/7.png" alt="image"></div>
        <div class="shape-5"><img src="assets/img/shape/8.png" alt="image"></div>
    </div>
</div>

<section class="features-section pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Explore AI <span>Capabilities</span></h2>
            <p style="font-size: 1.5rem;">Our AI services empower your business with advanced analytics, machine
                learning, and data-driven insights to foster innovation and growth.</p>
            <div class="bar"></div>
        </div>
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="features-content">



                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="!isMobileDev" class="work-section pb-100">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-12 pr-0" style="display: flex;justify-content: center;width: 100%;">
                <div class="work-image">
                    <img src="assets/img/work-bg.jpg" alt="image">
                    <a [href]="videoSrc" class="video-btn popup-youtube"><i
                            class="flaticon-play"></i></a>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="isMobileDev" class="work-section pb-100">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-12 pr-0" style="display: flex; justify-content: center; width: 100%;">
                <div class="work-image">
                    <img src="assets/img/work-bg.jpg" alt="image">
                    <a class="video-btn" #playIcon (click)="playVideo()"><i class="flaticon-play"></i></a>
                    <a class="close-btn" (click)="hideVideo()"><i class="flaticon-cancel"></i></a>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Overlaying the video and close button to ensure visibility -->
<div class="video-container" style="display: none;" #videoContainer>
    <video #videoPlayer autoplay playsinline loop class="sm-embedded-video" controls>
        <source src="./assets/videos/AI_Promo.mp4" type="video/mp4">
    </video>
    <a class="close-btn" (click)="hideVideo()"><i class="flaticon-close"></i></a>
    <a class="sound-btn" (click)="toggleSound()"><i class="flaticon-speaker"></i></a> <!-- Sound toggle button -->

</div>




<section class="services-section bg-background pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Explore AI <span>Capabilities</span></h2>
            <p style="font-size: 1.5rem;">Our AI services empower your business with advanced analytics, machine
                learning, and data-driven insights to foster innovation and growth.</p>
            <div class="bar"></div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-it"></i>
                    </div>
                    <h3>Machine Learning</h3>
                    <p>Enhance your business with custom ML models that automate decisions and streamline operations.
                    </p>
                    <a routerLink="/services-details" class="read-btn">Learn More</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon bg-deb0fe">
                        <i class="flaticon-setting"></i>
                    </div>
                    <h3>Robotic Process Automation</h3>
                    <p>Automate and optimize your daily tasks such as email automations with RPA to increase productivity and reduce costs.</p>
                    <a routerLink="/services-details" class="read-btn">Learn More</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon bg-79e8e2">
                        <i class="flaticon-promotion"></i>
                    </div>
                    <h3>Data Analytics</h3>
                    <p>Transform data into actionable insights to make informed decisions and gain a competitive edge.
                    </p>
                    <a routerLink="/services-details" class="read-btn">Learn More</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon bg-fcc774">
                        <i class="flaticon-cellphone"></i>
                    </div>
                    <h3>AI-Driven Security Solutions</h3>
                    <p>Enhance your cybersecurity with AI-driven monitoring and threat detection systems to protect your
                        digital assets.</p>
                    <a routerLink="/services-details" class="read-btn">Read More</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon bg-84b7fd">
                        <i class="flaticon-shopping-cart"></i>
                    </div>
                    <h3>AI Application Development</h3>
                    <p>Build robust mobile and web applications with AI functionalities to deliver personalized user
                        experiences and enhanced business processes.</p>
                    <a routerLink="/services-details" class="read-btn">Read More</a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon bg-fe929f">
                        <i class="flaticon-optimize"></i>
                    </div>
                    <h3>Natural Language Processing</h3>
                    <p>Implement NLP to automate customer service, enhance user interactions, and extract valuable
                        insights from large volumes of text data.</p>
                    <a routerLink="/services-details" class="read-btn">Read More</a>
                </div>
            </div>
        </div>
    </div>


</section>




<section class="choose-section pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Why Choose Us</h2>
            <p>Discover the unique advantages of our AI services that set us apart in the tech industry.</p>
            <div class="bar"></div>
        </div>
        <div class="row align-items-center" style="display: flex;
        justify-content: center;">
            <div class="col-lg-4 col-md-6">
                <div class="choose-text">
                    <div class="icon">
                        <i class="flaticon-shared-folder"></i>
                    </div>
                    <h3>Innovative AI Solutions</h3>
                    <p>Our AI solutions are built on the latest technologies, ensuring that your business stays ahead with advanced algorithms and smart data analytics.</p>
                </div>
                <div class="choose-text">
                    <div class="icon">
                        <i class="flaticon-laptop"></i>
                    </div>
                    <h3>Expertise in Machine Learning</h3>
                    <p>Our team comprises PhD-level AI researchers and experienced developers who bring deep expertise in machine learning and neural networks.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="image">
                    <img src="assets/img/mobile.png" alt="image">
                </div>
            </div>
            <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
                <div class="choose-text">
                    <div class="icon">
                        <i class="flaticon-quality"></i>
                    </div>
                    <h3>Customized AI Integration</h3>
                    <p>We don't just provide AI; we integrate it seamlessly with your existing systems, enhancing efficiency without disrupting your workflows.</p>
                </div>
                <div class="choose-text">
                    <div class="icon">
                        <i class="flaticon-target"></i>
                    </div>
                    <h3>AI Security and Reliability</h3>
                    <p>Our AI solutions are secured with the best practices in cybersecurity, ensuring that your data and processes are protected against any threats.</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="fun-facts-area pt-100 pb-70">
    <div class="container">
        <div class="row align-items-center" style="display: flex;
        justify-content: center;">
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-fun-fact">
                    <div class="icon">
                        <i class="flaticon-check"></i>
                    </div>
                    <h3 class="odometer" data-count="950">00</h3>
                    <p>AI Projects Completed</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-fun-fact">
                    <div class="icon">
                        <i class="flaticon-happy"></i>
                    </div>
                    <h3><span class="odometer" data-count="150">00</span></h3>
                    <p>Satisfied Clients</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-fun-fact">
                    <div class="icon">
                        <i class="flaticon-technical-support"></i>
                    </div>
                    <h3><span class="odometer" data-count="550">00</span></h3>
                    <p>AI Multi Service</p>
                </div>
            </div>

        </div>
    </div>
</section>

<!-- <section class="projects-section pt-100 pb-100">
    <div class="container-fluid">
        <div class="section-title">
            <h2>Projects</h2>


            <div class="bar"></div>
        </div>
        <div class="row">
            <div class="col-lg-3 col-md-12 p-0">
                <div class="single-projects-box two">
                    <div class="projects-image">
                        <img src="assets/img/projects/img8.jpg" alt="image">
                    </div>
                    <div class="projects-content">
                        <h3>Brand creation.</h3>

                    </div>
                    <a routerLink="/projects-details" class="link-btn"></a>
                </div>
            </div>
            <div class="col-lg-3 col-md-12 p-0">
                <div class="single-projects-box two">
                    <div class="projects-image">
                        <img src="assets/img/projects/img9.jpg" alt="image">
                    </div>
                    <div class="projects-content">
                        <h3>E-commerce.</h3>

                    </div>
                    <a routerLink="/projects-details" class="link-btn"></a>
                </div>
            </div>
            <div class="col-lg-3 col-md-12 p-0">
                <div class="single-projects-box two">
                    <div class="projects-image">
                        <img src="assets/img/projects/img10.jpg" alt="image">
                    </div>
                    <div class="projects-content">
                        <h3>App</h3>

                    </div>
                    <a routerLink="/projects-details" class="link-btn"></a>
                </div>
            </div>
            <div class="col-lg-3 col-md-12 p-0">
                <div class="single-projects-box two">
                    <div class="projects-image">
                        <img src="assets/img/projects/img11.jpg" alt="image">
                    </div>
                    <div class="projects-content">
                        <h3>Marketing strategies</h3>

                    </div>
                    <a routerLink="/projects-details" class="link-btn"></a>
                </div>
            </div>
            <div class="col-lg-3 col-md-12 p-0">
                <div class="single-projects-box two">
                    <div class="projects-image">
                        <img src="assets/img/projects/img12.jpg" alt="image">
                    </div>
                    <div class="projects-content">
                        <h3>Social media presence.</h3>

                    </div>
                    <a routerLink="/projects-details" class="link-btn"></a>
                </div>
            </div>
            <div class="col-lg-3 col-md-12 p-0">
                <div class="single-projects-box two">
                    <div class="projects-image">
                        <img src="assets/img/projects/img13.jpg" alt="image">
                    </div>
                    <div class="projects-content">
                        <h3>Online payments, including encryption</h3>

                    </div>
                    <a routerLink="/projects-details" class="link-btn"></a>
                </div>
            </div>
            <div class="col-lg-3 col-md-12 p-0">
                <div class="single-projects-box two">
                    <div class="projects-image">
                        <img src="assets/img/projects/img14.jpg" alt="image">
                    </div>
                    <div class="projects-content">
                        <h3>Budget.</h3>

                    </div>
                    <a routerLink="/projects-details" class="link-btn"></a>
                </div>
            </div>
            <div class="col-lg-3 col-md-12 p-0">
                <div class="single-projects-box two">
                    <div class="projects-image">
                        <img src="assets/img/projects/img15.jpg" alt="image">
                    </div>
                    <div class="projects-content">
                        <h3>Creative Web Develop</h3>
                        <span>Research and Startup</span>
                    </div>
                    <a routerLink="/projects-details" class="link-btn"></a>
                </div>
            </div>
        </div>
    </div>
</section> -->

<app-qr-code-popup style="width: 60%;" *ngIf="showQrCode" (click)="closeQrCodePopup()"
    [url]="'https://elevate-tech-ai.web.app/'"></app-qr-code-popup>
